export const APP_EVENTS_TABLE_CONFIG = (intl) => [
  {
    key: 'dg_ts_insert',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.dg_ts_insert' }),
    type: 'datetime',
  },
  {
    key: 'mensaje',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.mensaje' }),
  },
  {
    key: 'tipo_usuario',
    label: intl.formatMessage({ id: 'pages.application.detail.history.tableFields.responsable' }),
    type: 'responsable',
  },
]
